import {reactivateSite} from '@/api/admin';
import {useMutation, useQueryClient} from '@tanstack/react-query';

export function useReactivateSite() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (siteId: string) => reactivateSite(siteId),
        onSuccess: () => {
            queryClient.invalidateQueries(['admin', 'sites']);
            queryClient.invalidateQueries(['admin', 'stats']);
        }
    });
}
